import {
    SET_SIGNIN_NAV_HEADER
} from './all_action'

// action
export const set_signin_nav_header = (header_text) => ({
    type: SET_SIGNIN_NAV_HEADER,
    payload: {
        header_text
    }
});
